<template>
  <th v-if="isHeader">
    {{'Actions' | translate}}
  </th>
  <td v-else>
  <div class="custom-actions">
    <button class="btn btn-primary mb-1 edit-button" @click="itemAction('edit', rowData, rowIndex)"><i class="icons icon-note"></i>&nbsp;{{ 'Edit' | translate }}</button>
    <button class="btn btn-danger mb-1 delete-button" @click="itemAction('delete', rowData, rowIndex)"><i class="icons icon-trash"></i>&nbsp;{{ 'Delete' | translate }}</button>
    <button class="btn mb-1 delete-button" @click="popup(
   rowData, rowIndex)"><i class="icons icon-pencil"></i>&nbsp;{{ '' | translate }}</button>
    <b-modal @ok="saveEquipmentComment" v-model="showCommentPopup" :title="$t('Add comment for equipment: ') + currentEquipmentData.name || ''">
      <form>
        <div class="form-group">
          <input type="hidden" v-model="currentEquipmentData.id"></input>
          <textarea class="form-control" v-model="currentComment"></textarea>
          <input type="checkbox" v-model="isStockAudit">{{' Mark as audited' | translate}}</input>
        </div>
        <!-- Set default comment type in database -->
      </form>
    </b-modal>
  </div>
  </td>
</template>

<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'
export default {
  mixins: [VuetableFieldMixin],
  props: {
    rowData: {
      type: Object
      // required: true
    },
    rowIndex: {
      type: Number
    }
  },
  data: () => {
    return {
      currentComment: '',
      isStockAudit: true,
      showCommentPopup: false,
      currentEquipmentData: {}
    }
  },
  methods: {
    saveEquipmentComment (bvModalEvt) {
      bvModalEvt.preventDefault()
      var d = {}
      d['equipment_id'] = Object.assign({}, this.currentEquipmentData).name
      d['initiator'] = 'ADMIN'
      d['reason'] = (this.isStockAudit ? 'STOCK_AUDIT' : 'GENERAL_COMMENT')
      d['description'] = this.currentComment
      var vm = this
      this.$http.post('customerlog', {data: d}).then(function (res) {
        if (res.status === 200) {
          vm.$notify({
            group: 'full',
            text: res.data.msg
          })
          this.$parent.refresh()
          this.isStockAudit = true
          this.currentComment = ''
          this.currentEquipmentData = {}
          this.showCommentPopup = false
        } else {
          vm.$notify({
            group: 'full',
            text: res.data.msg
          })
        }
      })
    },
    popup (data, index) {
      this.currentEquipmentData = data
      this.showCommentPopup = !this.showCommentPopup
    },
    itemAction (action, data, index) {
      if (action === 'delete') {
        if (confirm(this.$t('Are you sure?'))) {
          this.$router.push({ path: this.$route.path + '/' + action + '/' + data.id })
        }
      } else {
        this.$router.push({ path: this.$route.path + '/' + action + '/' + data.id })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// VueTableEquipmentActions.vue?53269123